module.exports = __webpack_public_path__ + "img/check.1e0156f6.svg";